<template>
  <el-select
    class="v-select"
    :class="{ 'show-place-holder': placeholder, 'hide-border': styleConfig.border === 'none' }"
    clearable
    :placeholder="placeholder"
    :style="cssProps"
    v-model="selectedValue"
    @input="onInput"
  >
    <span v-if="withPrefix && selectedValue !== undefined" class="prefix-wrapper" slot="prefix">
      <slot name="prefix"><CircleIcon /></slot>
    </span>
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :style="cssProps">
    </el-option>
  </el-select>
</template>

<script>
import CircleIcon from '@/components/icon/Circle.vue';

export default {
  name: 'Select',
  components: {
    CircleIcon
  },
  props: {
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: '',
    styleConfig: {
      type: Object,
      default() {
        return {
          placeHolder: {}
        };
      }
    },
    withPrefix: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selectedValue = val;
      }
    }
  },
  computed: {
    cssProps() {
      return {
        '--placeHolderColor': this.styleConfig.placeHolderColor,
        '--borderRadius': this.styleConfig.borderRadius,
        '--boxShadow': this.styleConfig.boxShadow,
        '--padding': this.styleConfig.padding,
        '--fontSize': this.styleConfig.fontSize,
        '--fontFamily': this.styleConfig.fontFamily,
        '--color': this.styleConfig.color,
        '--border': this.styleConfig.border
      };
    }
  },
  methods: {
    onInput(value) {
      this.selectedValue = value;
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-select.show-place-holder {
  & {
    .el-select .el-input__inner,
    .el-input .el-input__inner {
      &::placeholder {
        opacity: 1;
        color: var(--placeHolderColor, #999999);
      }
    }
  }
}

/deep/ {
  .el-input__prefix {
    right: -20px;
  }
}

.el-select-dropdown__item {
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  color: $broker-black;

  &.selected {
    color: $primary-blue;
  }

  :hover {
    color: $primary-blue;
  }
}

.v-select {
  border-radius: var(--borderRadius);
  box-shadow: var(--boxShadow);
  padding: var(--padding);
}
/deep/.el-input__inner {
  font-size: var(--fontSize, '14px');
}
.hide-border {
  /deep/.el-input__inner {
    border-bottom: var(--border);
  }
}
.prefix-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
